<div class="artist-container" *ngIf="artists">
    <div class="artist-wrapper" *ngFor="let artist of artists">
        <div class="profile" (click)="goToArtist(artist._id)">
            <img class="avatar" *ngIf="artist.avatar" src="{{artist.avatar.thumbnail}}?resize=90,90" />
        </div>
        <strong class="title">{{artist.username}}</strong><br/>
    </div>
</div>